var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceSaveItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66825 5.83398C8.21032 5.83398 7.83358 6.21073 7.83358 6.66865L7.82738 17.8055L11.7502 15.5639C11.9039 15.476 12.0926 15.476 12.2463 15.5639L16.1696 17.8057V6.66865C16.1696 6.21073 15.7928 5.83398 15.3349 5.83398H8.66825ZM6.83358 6.66837C6.83373 5.65829 7.65813 4.83398 8.66825 4.83398H15.3349C16.3451 4.83398 17.1696 5.65844 17.1696 6.66865V18.6673C17.1696 18.8456 17.0747 19.0103 16.9205 19.0998C16.7664 19.1892 16.5763 19.1899 16.4215 19.1014L11.9982 16.5739L7.57497 19.1014C7.42018 19.1899 7.23 19.1892 7.07582 19.0997C6.92165 19.0102 6.82681 18.8453 6.8269 18.667L6.83358 6.66837Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceSaveItem);
export default __webpack_public_path__ + "static/media/marketplace_save_item.94612116388e05ac908a25de738a1db2.svg";
export { ForwardRef as ReactComponent };